import { useQuery } from '@tanstack/react-query';
import { getAccountApiTokens } from '../requests';

export function useGetAccountApiTokens(accountNumber?: string) {
  const query = useQuery({
    queryKey: ['security', 'trading', 'webapi', 'token', accountNumber],
    queryFn: () => getAccountApiTokens(accountNumber || ''),
    enabled: !!accountNumber,
    staleTime: 0,
    gcTime: 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
